export default {
	init() {
		const blocks = document.querySelectorAll('.wp-block-flip-blocks-team');

		if (!blocks.length) return;

		blocks.forEach((block) => {
            const popup = block.querySelector('#flip-team-popup-block');

			const closePopup = () => {
				setTimeout(() => {
					popup.classList.remove('is-open');
					document.body.classList.remove('no-scroll');
				}, 0);
			};

            if (!popup) return;

            const openBtns = block.querySelectorAll('.js-open-popup');

            openBtns.forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();

					const item = btn.closest('.block-team__list-item');
					if (!item) return;

					const data = item.querySelector('.block-team__popup-info');
					const bioSource = item.querySelector('.block-team__popup-bio');

					// set text
					popup.querySelector('.team-popup__name').textContent =
						data?.dataset.name || '';

					popup.querySelector('.team-popup__role').textContent =
						data?.dataset.role || '';

					// set image
					const img = popup.querySelector('.team-popup__image img');
					if (img) {
						img.src = data.dataset.image || '';
						img.alt = data.dataset.name || '';
					}

					// set bio (HTML)
					const bioEl = popup.querySelector('.team-popup__bio');
					if (bioEl) {
						bioEl.innerHTML = bioSource.innerHTML || '';
					}

					// open
					popup.classList.add('is-open');
					document.body.classList.add('no-scroll');
				});
			});

            // CLOSE POPUP
			const closeBtn = popup.querySelector('.team-popup__close-btn');
			if (closeBtn) {
				closeBtn.addEventListener('click', closePopup);
			}

			popup.addEventListener('click', (e) => {
				const inner = popup.querySelector('.team-popup__inner');
			
				if (inner && !inner.contains(e.target)) {
					closePopup();
				}
			});

            const inner = popup.querySelector('.team-popup__inner');
			if (inner) {
				inner.addEventListener('click', (e) => e.stopPropagation());
			}

            document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') {
					closePopup();
				}
			});

		});
	},
};